module.exports = __webpack_public_path__ + "static/media/video-icon.505df46b.svg";